export const RECEIVE_FILTERED_RESULTS = 'RECEIVE_FILTERED_RESULTS';

export const receiveUpdatedFilteredResults = (filters, allResults, resultsConfig, prompts) => ({
    type: RECEIVE_FILTERED_RESULTS,
    filters,
    allResults,
    resultsConfig,
    prompts
});

export const updateFilteredResults = (filters) => (dispatch, getState) => {
    const allResults = getState().entities.results;
    const resultsConfig = getState().app.assessment.resultsConfig;
    const prompts = getState().entities.prompts;

    return dispatch(receiveUpdatedFilteredResults(filters, allResults, resultsConfig, prompts));
}